module.exports = "/static/Images/pt-br/survey_no.png";